import { CONTENT_RELEASE, CONTENT_RELEASE_INFO } from '../content/contentVersion';
import { FOOTER_NEWSLETTER_CONTENT } from '../content/footer/newsletter';
import { FOOTER_COMPANY_CONTENT } from '../content/footer/company';
import { FOOTER_SECTION_CONTENT } from '../content/footer/sections';
import {
  FOOTER_LEGAL_SECTION,
  FOOTER_BOTTOM_LINKS_CONTENT,
  FOOTER_COPYRIGHT_SUFFIX_CONTENT
} from '../content/footer/legal';
import {
  FOOTER_SOCIAL_CONTENT,
  FOOTER_APP_DOWNLOAD_CONTENT
} from '../content/footer/appAndSocial';

export const FOOTER_CONTENT_VERSION = CONTENT_RELEASE;
export const FOOTER_CONTENT_AUDIT = {
  release: CONTENT_RELEASE,
  releasedOn: CONTENT_RELEASE_INFO?.releasedOn || null,
  owner: CONTENT_RELEASE_INFO?.owner || null,
  notes: CONTENT_RELEASE_INFO?.notes?.footer || []
};
export const FOOTER_NEWSLETTER = FOOTER_NEWSLETTER_CONTENT;
export const FOOTER_COMPANY = FOOTER_COMPANY_CONTENT;
export const FOOTER_SECTIONS = [...FOOTER_SECTION_CONTENT, FOOTER_LEGAL_SECTION];
export const FOOTER_SOCIAL = FOOTER_SOCIAL_CONTENT;
export const FOOTER_APP_DOWNLOAD = FOOTER_APP_DOWNLOAD_CONTENT;
export const FOOTER_BOTTOM_LINKS = FOOTER_BOTTOM_LINKS_CONTENT;
export const FOOTER_COPYRIGHT_SUFFIX = FOOTER_COPYRIGHT_SUFFIX_CONTENT;
